export default __webpack_public_path__ + "static/media/herb.31486cc2.svg";